export const getCssVarValue = (attr: string, defaultValue: any = null, element: HTMLElement | null = null) => {
    const styles = getComputedStyle(element ?? document.body);
    const value = styles.getPropertyValue(attr);

    return value.length ? value : defaultValue;
};
